var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "svg-icon",
      staticStyle: {
        width: "1.21875em",
        height: "1em",
        "vertical-align": "middle",
        fill: "currentColor",
        overflow: "hidden"
      },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1248 1024",
        version: "1.1"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M915.84 919.872l-52.928-91.648c4.48-2.496 12.64-7.36 16.96-10.048l67.52 82.848c-5.696 3.52-25.76 15.552-31.584 18.848M713.888 216.544a311.232 311.232 0 0 0-30.912-0.064l-4.8-105.92a455.04 455.04 0 0 1 40.736 0.064l-5.024 105.92zM520.384 268.16L463.04 179.008c11.392-7.328 23.168-14.144 35.264-20.416l48.768 94.112c-9.184 4.8-18.08 9.92-26.688 15.456z m355.776 0.64a337.568 337.568 0 0 0-26.592-15.584l49.088-93.92c12.096 6.304 23.84 13.184 35.2 20.576L876.16 268.8zM405.632 394.56L311.36 346.144c6.208-12.128 12.992-23.904 20.32-35.36l89.28 57.088c-5.504 8.64-10.624 17.536-15.36 26.72z m584.896 1.056a330.912 330.912 0 0 0-15.296-26.816l89.536-56.704c7.264 11.456 14.016 23.264 20.16 35.392l-94.4 48.128z m-726.432 171.2a434.208 434.208 0 0 1-0.192-40.704l105.92 4.48a380.864 380.864 0 0 0 0.128 30.912l-105.856 5.28z m867.328 1.6l-105.856-5.76a315.008 315.008 0 0 0 0.256-30.848l105.92-4.128a481.92 481.92 0 0 1-0.32 40.704zM334.08 781.568a439.808 439.808 0 0 1-20.64-35.072l93.76-49.44c4.8 9.12 10.048 18.016 15.68 26.624l-88.8 57.92z m726.496 1.376l-88.448-58.4c5.632-8.544 10.88-17.376 15.744-26.464l93.536 49.824c-6.4 12-13.344 23.712-20.832 35.04zM478.208 923.136c-5.824-3.264-26.432-23.584-32.064-27.104l77.088-75.36c5.024 3.456 9.088 6.592 14.272 10.016l-59.296 92.448z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M961.696 999.776c161.344-93.696 262.784-265.632 262.784-455.36 0-290.88-235.808-526.688-526.688-526.688S171.104 253.536 171.104 544.448c0 189.696 101.44 361.6 262.784 455.36l48.192-83.04c-132.064-76.736-214.976-217.248-214.976-372.352 0-237.856 192.8-430.688 430.688-430.688 237.888 0 430.688 192.832 430.688 430.72 0 155.072-82.88 295.584-214.976 372.32l48.192 83.008z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M763.456 544.448a65.6 65.6 0 1 1-131.264 0 65.6 65.6 0 0 1 131.264 0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M695.84 569.92l-258.656-149.312 22.08-38.24 258.656 149.344zM144.128 169.44L52.704 110.144l-47.744 73.6 91.456 59.296-21.344 32.896 118.848-21.92-28.448-117.44z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }